import React from 'react';
import { Container, Spinner } from './styles';
import logo from '../../assets/logo.png';

type Props = {
    loading: boolean;
    webapp?: boolean;
};

const Loading: React.FC<Props> = ({ loading, webapp = true }) => {
    return loading ? (
        <Container $webapp={webapp}>
            <Spinner src={logo} alt="Flix Media Ticketx" />
        </Container>
    ) : (
        <></>
    );
};

export { Loading };
